import React from 'react'

import { Container } from './styles.js'

class ContentBlock extends React.Component {

    render() {
        return (
            <Container dangerouslySetInnerHTML={{
                __html: this.props.data
            }}></Container>
        )
    }

}

export default ContentBlock